import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const DAY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Day.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const DAY_CONFIG = {
  entityName: 'Day',
  localizationKey: 'General::Entity.Day',
  fields: DAY_FIELDS,
  permission: 'ControllingCalendar.Days',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
